import { useAuth0 } from '@auth0/auth0-react'
import { ButtonLink } from '@designsforhealth/dfh-react-components'
import { useLocation } from '@gatsbyjs/reach-router'
import React from 'react'
import styled from 'styled-components'

import { usePageUrl } from '../../lib/pages'
import { Maybe } from '../../utils/types'

export interface LoginLinkProps {
  className?: string
  redirectPath?: Maybe<string>
}

const LoginLink: React.FC<LoginLinkProps> = ({ className, children, redirectPath }) => {
  const { loginWithRedirect } = useAuth0()
  const location = useLocation()
  const { getPagePath, navigate } = usePageUrl()

  return (
    <ButtonLink
      className={className}
      onClick={() => {
        loginWithRedirect({
          // use relative path to avoid unloading application
          appState: {
            returnTo: redirectPath
              ? getPagePath(redirectPath)
              : location
                ? `${location.pathname}${location.search}${location.hash}`
                : '',
          },
        }).catch(() => navigate('/login'))
      }}
    >
      {children}
    </ButtonLink>
  )
}

const StyledLoginLink = styled(LoginLink)`
  font-family: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  line-height: inherit;
`

export default StyledLoginLink
